import Parser from 'html-react-parser';
import { useEffect, useState } from "react";
import PostApiCall from "../../Helper/PostApi";
import { Skeleton } from 'antd';
import GetSeoData from '../../Helper/GetSeoData';

export default function StaticPage() {
  const [staticPages, setStaticPages] = useState([]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // document.title = pagename; // can be used later
    PostApiCall.postRequest(
      {
        whereclause: `where fld_route = '${window.location.pathname}'`,
      },
      "GetStaticPages"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setStaticPages(obj1.data);
        }
      })
    );
  }, []);
  const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  let seoType;
  let pagesData = window.location.pathname.split("/")[1].replace(/-/g, " ");
  if (pagesData === "return policy") {
    seoType = 'Return and Refund Policy';
  } else if (pagesData === "orders and acceptance policy") {
    seoType = "Disclaimer";
  } else {
    seoType = pagesData;
  }

  return (
    <>
      <section className="section-spacing-x blank-section section-spacing-x-mobile py-4">
        <GetSeoData type={capitalizeWords(seoType)} id={null} />

        <div className="container-fluid">
          <div className="row">
            {staticPages.length > 0 ?
              <div className="col-12">
                <h1 className="text-center main-heading mb-0">
                  {staticPages[0]?.fld_page_heading}
                </h1>
                <p>
                  {Parser(
                    ("<p>" + staticPages[0]?.fld_content + "</p>")
                      .replace(/font-family/g, "")
                      .replace(/<br\/?>/gi, " ")
                  )}
                </p>
              </div>
              :
              <Skeleton className="mt-4" />}
          </div>
        </div>
      </section>
    </>
  );
}
